export const transformResponsePerformanceInsightsEarnings = earnings => {
  return {
    currency: earnings.currency,
    net_sales: earnings.net_sales,
    cogs: earnings.cogs,
    product_margin: earnings.product_margin,
    product_margin_percentage: earnings.product_margin_percentage,
    refunds: earnings.refunds,
    refunds_percentage: earnings.refunds_percentage,
    logistics: earnings.logistics,
    logistics_percentage: earnings.logistics_percentage,
    customs: earnings.customs,
    customs_percentage: earnings.customs_percentage,
    operating_margin: earnings.operating_margin,
    operating_margin_percentage: earnings.operating_margin_percentage,
    has_missing_cogs: earnings.has_missing_cogs,
    has_missing_logistics_or_customs: earnings.has_missing_logistics_or_customs,
  }
}
